import { RESET } from "../actions/actionTypes";

// State for the "What's new" guided tour. It is a single tour with a single step
// counter that spans two pages: a site on the World Map, then the same site on
// Analytics, which it navigates to on its own. We drive `stepIndex` from the
// store so the controller mounted in Layout can render Joyride across that route
// change.
//
// `startedOnce` is what keeps the tour to a single run: without it, a tour
// abandoned halfway restarts from the beginning every time the user opens a
// site again.
//
// Nothing here is persisted (only the `user` reducer is): a tour left unfinished
// is offered again on the next load of the app, and `completed_guided_tour` is
// what closes it for good.
const initialState = {
  active: false,
  stepIndex: 0,
  startedOnce: false,
};

export default function guidedTour(state = initialState, action) {
  switch (action.type) {
    case "GUIDED_TOUR_START":
      return { ...state, active: true, stepIndex: 0, startedOnce: true };
    case "GUIDED_TOUR_SET_STEP":
      return { ...state, stepIndex: action.stepIndex };
    case "GUIDED_TOUR_STOP":
      return { ...initialState, startedOnce: state.startedOnce };
    // Logout: `startedOnce` is per user, so it must not outlive the session and
    // deny the tour to whoever logs in next.
    case RESET:
      return initialState;
    default:
      return state;
  }
}
